import * as Bixby from './../../core';

export interface CloDealState {
  isLoading: boolean;
  error?: Bixby.Models.BixbyError;
  currentCloDeal?: Bixby.Models.CloDeal;
  heatMapActive: boolean;
  cloDeals?: Bixby.Models.CloDealSlim[];
  isAddingCloDealToClient: boolean;
  isDeletingCloDealFromClient?: boolean;
  deletingCloDealFromClientError?: Bixby.Models.BixbyError;
}

export const CLO_DEAL_LOADING = 'CLO_DEAL_LOADING';
export const CLO_DEAL_SUCCESS = 'CLO_DEAL_SUCCESS';
export const ALL_CLO_DEAL_SUCCESS = 'ALL_CLO_DEAL_SUCCESS';
export const CLO_DEAL_FAILURE = 'CLO_DEAL_FAILURE';
export const HEATMAP_ON = 'HEATMAP_ON';
export const HEATMAP_OFF = 'HEATMAP_OFF';
export const CREATE_CLO_DEAL = 'CREATE_CLO_DEAL';
export const ADD_CLIENT_CLO_DEAL = 'ADD_CLIENT_CLO_DEAL';
export const ADD_CLIENT_CLO_DEAL_SUCCESS = 'ADD_CLIENT_CLO_DEAL_SUCCESS';
export const ADD_CLIENT_CLO_DEAL_FAILURE = 'ADD_CLIENT_CLO_DEAL_FAILURE';
export const DELETE_CLIENT_CLO_DEAL = 'DELETE_CLIENT_CLO_DEAL';
export const DELETE_CLIENT_CLO_DEAL_SUCCESS = 'DELETE_CLIENT_CLO_DEAL_SUCCESS';
export const DELETE_CLIENT_CLO_DEAL_FAILURE = 'DELETE_CLIENT_CLO_DEAL_FAILURE';

interface CloDealLoading extends Bixby.Models.BixbyAction<undefined, typeof CLO_DEAL_LOADING> {
  type: typeof CLO_DEAL_LOADING;
}

interface CloDealSuccess extends Bixby.Models.BixbyAction<Bixby.Models.CloDeal, typeof CLO_DEAL_SUCCESS> {
  type: typeof CLO_DEAL_SUCCESS;
  payload: Bixby.Models.CloDeal;
}

interface AllCloDealsSuccess extends Bixby.Models.BixbyAction<Bixby.Models.CloDealSlim[], typeof ALL_CLO_DEAL_SUCCESS> {
  type: typeof ALL_CLO_DEAL_SUCCESS;
  payload: Bixby.Models.CloDealSlim[];
}

interface CloDealFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof CLO_DEAL_FAILURE> {
  type: typeof CLO_DEAL_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface HeatMapOn extends Bixby.Models.BixbyAction<boolean, typeof HEATMAP_ON> {
  type: typeof HEATMAP_ON;
  payload: true;
}

interface HeatMapOff extends Bixby.Models.BixbyAction<boolean, typeof HEATMAP_OFF> {
  type: typeof HEATMAP_OFF;
  payload: false;
}

interface CreateCloDeal extends Bixby.Models.BixbyAction<Bixby.Models.CloDeal, typeof CREATE_CLO_DEAL> {
  type: typeof CREATE_CLO_DEAL;
  payload: Bixby.Models.CloDeal;
}

interface AddClientCloDeal extends Bixby.Models.BixbyAction<undefined, typeof ADD_CLIENT_CLO_DEAL> {
  type: typeof ADD_CLIENT_CLO_DEAL;
}

interface AddClientCloDealSuccess extends Bixby.Models.BixbyAction<boolean, typeof ADD_CLIENT_CLO_DEAL_SUCCESS> {
  type: typeof ADD_CLIENT_CLO_DEAL_SUCCESS;
  payload: boolean;
}

interface AddClientCloDealFailure extends Bixby.Models.BixbyAction<undefined, typeof ADD_CLIENT_CLO_DEAL_FAILURE> {
  type: typeof ADD_CLIENT_CLO_DEAL_FAILURE;
}

interface DeleteClientCloDeal extends Bixby.Models.BixbyAction<undefined, typeof DELETE_CLIENT_CLO_DEAL> {
  type: typeof DELETE_CLIENT_CLO_DEAL;
}

interface DeleteClientCloDealSuccess extends Bixby.Models.BixbyAction<boolean, typeof DELETE_CLIENT_CLO_DEAL_SUCCESS> {
  type: typeof DELETE_CLIENT_CLO_DEAL_SUCCESS;
  payload: boolean;
}

interface DeleteClientCloDealFailure extends Bixby.Models.BixbyAction<undefined, typeof DELETE_CLIENT_CLO_DEAL_FAILURE> {
  type: typeof DELETE_CLIENT_CLO_DEAL_FAILURE;
}

export type CloDealActionTypes =
  | CloDealLoading
  | CloDealFailure
  | CloDealSuccess
  | HeatMapOff
  | HeatMapOn
  | AllCloDealsSuccess
  | CreateCloDeal
  | AddClientCloDeal
  | AddClientCloDealSuccess
  | AddClientCloDealFailure
  | DeleteClientCloDeal
  | DeleteClientCloDealSuccess
  | DeleteClientCloDealFailure
